<template>
  <div class="wrapper" v-html="compileMarkdown">
  </div>
</template>
<script>
import MarkdownIt from "markdown-it";
import sanitizer from "markdown-it-sanitizer";
import PolicyText from "@/assets/policy.md";

export default {
  data () {
    return {
      markdown: new MarkdownIt({
        html: true,
        breaks: true,
        linkify: true,
        typographer: true
      }).use(sanitizer),
      source: PolicyText
    };
  },
  computed: {
    compileMarkdown() {
      return this.markdown.render(this.source);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../static/scss/markdown.scss";
</style>
